module.exports = __webpack_public_path__ + "static/media/current_exam.5334f8e4.svg";